"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gateNumber = exports.gateCommandSent = exports.banDeleted = exports.adminVehicleBanID = exports.adminBanID = exports.adminParkingEventHistory = exports.adminUsers = exports.adminUser = void 0;
const typebox_1 = require("@sinclair/typebox");
const enums_1 = require("../enums");
const string_1 = require("../options/string");
const ban_1 = require("./ban");
const parkingEvent_1 = require("./parkingEvent");
const user_1 = require("./user");
/**
 * Further extends {@link user} to make it have all fields necessary for admin UI.
 */
exports.adminUser = typebox_1.Type.Intersect([
    user_1.user,
    typebox_1.Type.Object({
        status: typebox_1.Type.Enum(enums_1.UserStatus, {
            description: 'current status of the user',
            example: enums_1.UserStatus.Parking,
        }),
        bans: typebox_1.Type.Array(ban_1.ban, {
            description: 'a list of user\'s bans',
        }),
        vehicles: typebox_1.Type.Array(parkingEvent_1.licensePlate, {
            description: 'a list of user\'s past vehicles',
        }),
    }),
]);
/**
 * Defines the format used for recentVehicles object.
 */
exports.adminUsers = typebox_1.Type.Object({
    users: typebox_1.Type.Array(exports.adminUser, {
        description: 'a list of users for admin UI',
    }),
});
/**
 * A list of parking events that is used when retrieving the parking event history.
 */
exports.adminParkingEventHistory = typebox_1.Type.Object({
    parkingEvents: typebox_1.Type.Array(parkingEvent_1.dbParkingEvent, {
        description: 'a list of all parking events',
    }),
});
/**
 * Unique identifier type used to look up bans when using path parameters.
 */
exports.adminBanID = typebox_1.Type.Object({
    banID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'unique identifier of a ban' })),
});
/**
 * Unique identifier type used to look up vehicle bans when using path parameters.
 */
exports.adminVehicleBanID = typebox_1.Type.Object({
    banID: typebox_1.Type.String(Object.assign(Object.assign({}, string_1.uuid), { description: 'unique identifier of a vehicle ban' })),
});
/**
 * An empty response body type for deleting a ban or vehicle ban.
 */
// eslint-disable-next-line import/prefer-default-export
exports.banDeleted = typebox_1.Type.Null({
    description: 'ban deleted',
});
/**
 * An empty response body type for controlling the gates.
 */
// eslint-disable-next-line import/prefer-default-export
exports.gateCommandSent = typebox_1.Type.Null({
    description: 'gate command sent',
});
/**
 * Number identifier type used to find the right gate using path parameters.
 */
exports.gateNumber = typebox_1.Type.Object({
    gateNumber: typebox_1.Type.String({
        description: 'Gate number',
        example: '0',
    }),
});
//# sourceMappingURL=admin.js.map